import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '@core';
import { InvestigationDashboardTimeframe } from '../../domain/enums/investigation-dashboard-timeframe.enum';
import { InvestigationDashboardPreferencesResponseDto } from '../dtos/investigation-dashboard-preferences-response.dto';
import { InvestigationDashboardWidgetDataResponseDto } from '../dtos/investigation-dashboard-widget-data-response.dto';
import { InvestigationDashboardWidgetResponseDto } from '../dtos/investigation-dashboard-widget-response.dto';
import { UpdateInvestigationDashboardPreferencesRequestDto } from '../dtos/update-investigation-dashboard-preferences-request.dto';

@Injectable({ providedIn: 'root' })
export class InvestigationDashboardApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/investigations/dashboard`;

  public getMe(): Observable<InvestigationDashboardPreferencesResponseDto> {
    return this._http.get<InvestigationDashboardPreferencesResponseDto>(`${this._baseUrl}/me`);
  }

  public getWidgets(): Observable<InvestigationDashboardWidgetResponseDto[]> {
    return this._http.get<InvestigationDashboardWidgetResponseDto[]>(`${this._baseUrl}/widgets`);
  }

  public getWidgetData(
    widgetId: string,
    timeframe?: InvestigationDashboardTimeframe,
  ): Observable<InvestigationDashboardWidgetDataResponseDto> {
    let params = new HttpParams();
    if (timeframe !== undefined) params = params.set('timeframe', timeframe);
    return this._http.get<InvestigationDashboardWidgetDataResponseDto>(
      `${this._baseUrl}/widgets/${widgetId}/data`,
      { params },
    );
  }

  public updatePreferences(request: UpdateInvestigationDashboardPreferencesRequestDto): Observable<void> {
    return this._http.put<void>(`${this._baseUrl}/preferences`, request);
  }
}
